import React from 'react'
import dollar from '../../src/assets/Signin/Dollar.svg'
import dollarC from '../../src/assets/Reports/DollarC.svg'
 
const Reportstotal = ({
  data,
  handleCheckLocaClick,
  handleCheckMethodClick,
  checkLoca,
  checkMethod,
  onclearfilters
}) => {
 
  /* ---------------- CLICK HANDLERS ---------------- */
const excludedPatientIds = [2336,  1468, 12241];
const filteredData = data.filter(
  (item) => !excludedPatientIds.includes(Number(item.patientid))
);
const handleLocationClick = (loc1, loc2) => {
  // STRIPE case → force set both
  if (loc1 === 'kiosk' && loc2 === 'online') {
    handleCheckLocaClick('stripe');
    return;
  }

  // normal case
  handleCheckLocaClick(loc1);
}
 
  const handleMethodClick = (id1, id2) => {
    const methods = [id1, id2].filter(Boolean)
    methods.forEach(m => handleCheckMethodClick(m))
  }
 
  const handleGrandTotalClick = () => {
    onclearfilters()
  }
 
  /* ---------------- CALCULATIONS ---------------- */
 
  const locationAmount = filteredData.reduce((acc, x) => {
    if (x.payment_location) {
      acc[x.payment_location] =
        (acc[x.payment_location] || 0) + (x.amount || 0)
    }
    return acc
  }, {})
 const squareAmount = filteredData.reduce((acc, x) => {
  const method = Number(x.payment_method)
  if (method === 1 || method === 2) {
    return acc + (x.amount || 0)
  }
  return acc
}, 0)

const stripeAmount = filteredData.reduce((acc, x) => {
  const method = Number(x.payment_method)
  if (method === 6) {
    return acc + (x.amount || 0)
  }
  return acc
}, 0)
  const typeAmount = filteredData.reduce((acc, x) => {
    if (x.type === 'CASH' || x.type === 'CARECREDIT' || x.type === 'CHECK') {
      acc[x.type] = (acc[x.type] || 0) + (x.amount || 0)
    } else if (x.type === 'CREDIT/DEBIT' || x.type === 'MC/VISA') {
      acc['CARD'] = (acc['CARD'] || 0) + (x.amount || 0)
    }
    return acc
  }, {})
 
  const onlineAmount =
    (locationAmount['Online Check-In App'] || 0) +
    (locationAmount['Patient App'] || 0)
 
  const practiceAmount = locationAmount['Practice App'] || 0
  const kioskAmount = locationAmount['Kiosk'] || 0
  const totalAmount = filteredData.reduce((a, x) => a + (x.amount || 0), 0)
  // const stripeAmount = onlineAmount + kioskAmount
 
  /* ---------------- SELECTED CHECK ---------------- */
 
  const isLocationSelected = (l) => checkLoca.includes(l)
  const isMethodSelected = (m) => checkMethod.includes(m)
 
  /* ---------------- UI ---------------- */
 
  return (
    <div>
      <div className='flex w-full mt-2'>
 
        {/* GRAND TOTAL */}
        <div
          onClick={handleGrandTotalClick}
          className='w-[20%] bg-[#E17954] mr-2 text-white rounded-[10px] px-4 py-2 p-4 cursor-pointer'
        >
          <div className='flex flex-col gap-16'>
            <div className='flex justify-between'>
              <div>GRAND TOTAL</div>
           
            </div>
            <div className='flex text-lg font-bold'>
         <span className=''>$ </span>
              {totalAmount.toFixed(2)}
            </div>
          </div>
        </div>
 
        {/* ONLINE */}
        <div className='flex flex-col gap-[6px] w-[20%] mx-2'>
 
          <div
            onClick={() => handleLocationClick('online')}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isLocationSelected('online') ? 'bg-[#E179541A]' : ''}`}
          >
            ONLINE
            <div>${onlineAmount.toFixed(2)}</div>
          </div>
 
          <div
            onClick={() => handleLocationClick('kiosk')}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isLocationSelected('kiosk') ? 'bg-[#E179541A]' : ''}`}
          >
            KIOSK
            <div>${kioskAmount.toFixed(2)}</div>
          </div>
 
        </div>
 
        {/* CARD + CASH */}
        <div className='flex flex-col gap-[6px] w-[20%] mx-2'>
 
          <div
            onClick={() => handleMethodClick(1,6)}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isMethodSelected(1) || isMethodSelected(6) ? 'bg-[#E179541A]' : ''}`}
          >
            CARD (SQUARE+STRIPE)
            <div>${(typeAmount['CARD'] || 0).toFixed(2)}</div>
          </div>
 
          <div
            onClick={() => handleMethodClick(5)}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isMethodSelected(5) ? 'bg-[#E179541A]' : ''}`}
          >
            CASH
            <div>${(typeAmount['CASH'] || 0).toFixed(2)}</div>
          </div>
 
        </div>
 
        {/* SQUARE + STRIPE */}
        <div className='flex flex-col gap-[6px] w-[20%] mx-2'>
 
          <div
            onClick={() => handleLocationClick('front')}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isLocationSelected('front') ? 'bg-[#E179541A]' : ''}`}
          >
            SQUARE
            <div>${squareAmount.toFixed(2)}</div>
          </div>
 
        <div
  onClick={() => handleLocationClick('kiosk','online')}
  className={`border rounded-[10px] p-3 cursor-pointer
  ${checkLoca.includes('kiosk') && checkLoca.includes('online')
    ? 'bg-[#E179541A]'
    : ''}`}
>
  STRIPE(KIOSK + ONLINE)
  <div>${stripeAmount.toFixed(2)}</div>
</div>
 
        </div>
 
        {/* CARE CREDIT + CHECK */}
        <div className='flex flex-col gap-[6px] w-[18%] mx-2'>
 
          <div
            onClick={() => handleMethodClick(3)}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isMethodSelected(3) ? 'bg-[#E179541A]' : ''}`}
          >
            CARECREDIT
            <div>${(typeAmount['CARECREDIT'] || 0).toFixed(2)}</div>
          </div>
 
          <div
            onClick={() => handleMethodClick(4)}
            className={`border rounded-[10px] p-3 cursor-pointer
            ${isMethodSelected(4) ? 'bg-[#E179541A]' : ''}`}
          >
            CHECK
            <div>${(typeAmount['CHECK'] || 0).toFixed(2)}</div>
          </div>
 
        </div>
 
      </div>
    </div>
  )
}
 
export default Reportstotal